import {
    KioskGeneralPreferences,
    KioskPrinterPreferences,
    KioskProductDisplayOrder,
    KioskProductPreferences,
    KioskStartScreenOptions,
    KioskThemePreferences,
} from "types";

export const kioskGeneralPreferenceDefaults: KioskGeneralPreferences = {
    kioskStartScreenLocation: KioskStartScreenOptions.HOME,
    kioskHomeShowPurchaseBtn: true,
    kioskHomeShowCheckinBtn: true,
    kioskHomeShowWaiversBtn: true,
    kioskIdleResetTimeEnabled: true,
    kioskIdleResetTime: 1,
    kioskSettingsPassword: "",
    kioskPurchaseNameRequired: true,
    kioskPurchasePhoneRequired: true,
    kioskPurchaseEmailRequired: false,
};

export const kioskPrinterPreferencesDefaults: KioskPrinterPreferences = {
    kioskPrinterTicketImage: "",
    kioskPrinterTicketMessage: "",
    kioskPrinterPrintReceipts: false,
    kioskPrinterPrintQrTickets: true,
};

export const kioskProductPreferenceDefaults: KioskProductPreferences = {
    kioskProductDisplay: KioskProductDisplayOrder.LIST,
    kioskProductList: [],
};

export const kioskThemePreferenceDefaults: KioskThemePreferences = {
    kioskHomeBackground: "",
    kioskHeaderImage: "",
    kioskAttractVideo: "",
};
